
import { defineComponent, ref, watch, onMounted } from "vue";
import { ApiBase } from "@/core/api";
import { useI18n } from "vue-i18n";

interface option {
  label: string;
  value: string;
}

export default defineComponent({
  name: "mb-live-search",
  props: {
    label: { type: String, default: "", required: true },
    shortKey: { type: String, default: "" },
    modelValue: { type: String, default: "" },
    optionSource: { type: String, default: "" },
    optionSourceType: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const { t, te } = useI18n();
    const loading = ref(false);
    const options = ref<option[]>([]);
    const selectVal = ref(props.modelValue);

    watch(
      () => props.modelValue,
      (newVal) => {
        selectVal.value = newVal;
        if (props.optionSourceType == "remote") {
          if (props.optionSource == "pim_brand") {
            getBrandInitOptions(newVal);
          } else if (props.optionSource == "merchant") {
            getMerchantInitOptions(newVal);
          } else if (props.optionSource == "account") {
            getAccountInitOptions(newVal);
          } else if (props.optionSource == "user") {
            getUserInitOptions(newVal);
          }
        }
      }
    );

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const remoteMethod = (query: string) => {
      if (query) {
        loading.value = true;
        if (props.optionSourceType == "remote") {
          if (props.optionSource == "pim_brand") {
            getBrandOptions(query);
          } else if (props.optionSource == "merchant") {
            getMerchantOptions(query);
          } else if (props.optionSource == "account") {
            getAccountOptions(query);
          } else if (props.optionSource == "user") {
            getUserOptions(query);
          }
        }
      } else {
        options.value = [];
      }
    };

    const getBrandOptions = async (keywork) => {
      const { data } = await ApiBase.getBrandSourceData({
        search_value: keywork,
      });
      loading.value = false;
      if (data.code == 0) {
        options.value = data.data;
      }
    };

    const getBrandInitOptions = async (val) => {
      if (val) {
        const { data } = await ApiBase.getBrandSourceData({
          id: val,
        });
        if (data.code == 0) {
          options.value = data.data;
        }
      }
    };

    const getMerchantOptions = async (keywork) => {
      const { data } = await ApiBase.getMerchantSourceData({
        search_value: keywork,
      });
      loading.value = false;
      if (data.code == 0) {
        options.value = data.data;
      }
    };

    const getMerchantInitOptions = async (val) => {
      if (val) {
        const { data } = await ApiBase.getMerchantSourceData({
          id: val,
        });
        if (data.code == 0) {
          options.value = data.data;
        }
      }
    };

    const getAccountOptions = async (keywork) => {
      const { data } = await ApiBase.getAccountSourceData({
        search_value: keywork,
      });
      loading.value = false;
      if (data.code == 0) {
        options.value = data.data;
      }
    };

    const getAccountInitOptions = async (val) => {
      if (val) {
        const { data } = await ApiBase.getAccountSourceData({
          id: val,
        });
        if (data.code == 0) {
          options.value = data.data;
        }
      }
    };

    const getUserOptions = async (keywork) => {
      const { data } = await ApiBase.getUserSourceData({
        search_value: keywork,
      });
      loading.value = false;
      if (data.code == 0) {
        options.value = data.data;
      }
    };

    const getUserInitOptions = async (val) => {
      if (val) {
        const { data } = await ApiBase.getUserSourceData({
          id: val,
        });
        if (data.code == 0) {
          options.value = data.data;
        }
      }
    };

    const handleChange = (val) => {
      selectVal.value = val;
      context.emit("update:modelValue", val);
    };

    onMounted(() => {
      if (props.optionSourceType == "remote") {
        if (props.optionSource == "pim_brand") {
          getBrandInitOptions(selectVal.value);
        } else if (props.optionSource == "merchant") {
          getMerchantInitOptions(selectVal.value);
        } else if (props.optionSource == "account") {
          getAccountInitOptions(selectVal.value);
        } else if (props.optionSource == "user") {
          getUserInitOptions(selectVal.value);
        }
      }
    });

    return {
      translate,
      loading,
      options,
      selectVal,
      remoteMethod,
      handleChange,
    };
  },
});
